import { v4 } from "uuid";
import { AI_NAMES, CHESS_ENGINE } from "../constants";
const AI_USERNAME_PREFIX = "ai_";
function randomRating() {
    return Math.floor(Math.random() * 1000);
}
export const BOT_PLAYERS = Array(5)
    .fill(0)
    .flatMap((_, i) => ["A", "B", "C", "D", "E"].map((x) => ({
    username: `${AI_USERNAME_PREFIX}sf_${i + 1}${x}`.toLowerCase(),
    first_name: `Bot ${i + 1}${x}`,
    school: { school_name: "SF Bot Factory" },
    aiLevel: i + 1,
    aiEngine: CHESS_ENGINE.STOCKFISH,
    stats: { rating: randomRating() },
})));
const AI_PLAYERS = [
    {
        username: "ai_player_1",
        first_name: "Chessie",
        school: { school_name: "Level 1" },
        aiLevel: 1,
        aiEngine: CHESS_ENGINE.STOCKFISH,
        stats: { rating: randomRating() },
    },
    {
        username: "ai_player_2",
        first_name: "Professor Ninja",
        school: { school_name: "Level 2" },
        aiLevel: 3,
        aiEngine: CHESS_ENGINE.STOCKFISH,
        stats: { rating: randomRating() },
    },
    {
        username: "ai_player_3",
        first_name: "Alien Brain",
        school: { school_name: "Level 3" },
        aiLevel: 12,
        aiEngine: CHESS_ENGINE.STOCKFISH,
        stats: { rating: randomRating() },
    },
    ...BOT_PLAYERS,
];
export const randomBotPlayer = function () {
    return BOT_PLAYERS[Math.floor(Math.random() * BOT_PLAYERS.length)];
};
export const aiPlayer = function (playerId) {
    const oldAi = AI_PLAYERS.find((p) => p.username === playerId);
    if (oldAi)
        return oldAi;
    const newAiInfo = playerId.split("_");
    return toAiProfile(null, Number(newAiInfo[1]));
};
export const isAiPlayer = function (player) {
    return (player.aiLevel || AI_PLAYERS.find((p) => p.username === player.username));
};
export const isAiUsername = function (username) {
    return username && username.startsWith(AI_USERNAME_PREFIX);
};
export const toAiProfile = function (engine, level) {
    const selectedEngine = engine || level >= 10 ? CHESS_ENGINE.LOZZA : CHESS_ENGINE.P4WN;
    let aiName = "";
    if (level <= 4) {
        aiName = AI_NAMES.CHESSIE;
    }
    else if (level <= 8) {
        aiName = AI_NAMES.PROFESSOR_NINJA;
    }
    else {
        aiName = AI_NAMES.ALIEN_BRAIN;
    }
    return {
        user_id: v4(),
        username: `P4zza_${level}`,
        first_name: aiName,
        school: { school_name: `Level ${level}` },
        aiLevel: level,
        aiEngine: selectedEngine,
    };
};
